import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import PropTypes from 'prop-types';

import styles from './styles';
import { JOB_STATUS_CODES } from '../../constants';

// eslint-disable-next-line consistent-return
export const getJobStatusColorClass = (classes, statusCode) => {
  switch (statusCode) {
    case JOB_STATUS_CODES.STATUS_01:
      return classes.status1;
    case JOB_STATUS_CODES.STATUS_02:
      return classes.status2;
    case JOB_STATUS_CODES.STATUS_03:
      return classes.status3;
    case JOB_STATUS_CODES.STATUS_04:
      return classes.status4;
    default:
      // eslint-disable-next-line no-console
      console.error('reach unknown case');
  }
};

const JobStatus = ({ classes, statusCode, handleJobStatusChange, jobId }) => (
  <div className={classNames(classes.status)}>
    <FormControl className={classes.formControl}>
      <Select
        value={statusCode}
        onChange={event => handleJobStatusChange(jobId, event)}
        inputProps={{
          name: 'status',
          id: 'filled-status-dropdown',
        }}
        className={classes.statusDropdown}
        disableUnderline
        native
      >
        <option
          value={JOB_STATUS_CODES.STATUS_01}
          className={classes.statusDropdownItem}
          disabled={statusCode === JOB_STATUS_CODES.STATUS_01}
        >
          New - Action Required
        </option>
        <option
          value={JOB_STATUS_CODES.STATUS_02}
          className={classes.statusDropdownItem}
          disabled={statusCode === JOB_STATUS_CODES.STATUS_02}
        >
          Customer Contacted
        </option>
        <option
          value={JOB_STATUS_CODES.STATUS_03}
          className={classes.statusDropdownItem}
          disabled={statusCode === JOB_STATUS_CODES.STATUS_03}
        >
          Tender Successful
        </option>
        <option
          value={JOB_STATUS_CODES.STATUS_04}
          className={classes.statusDropdownItem}
          disabled={statusCode === JOB_STATUS_CODES.STATUS_04}
        >
          Not Progressing - Archive
        </option>
      </Select>
    </FormControl>
  </div>
);

JobStatus.propTypes = {
  classes: PropTypes.object.isRequired,
  statusCode: PropTypes.oneOf([
    JOB_STATUS_CODES.STATUS_01,
    JOB_STATUS_CODES.STATUS_02,
    JOB_STATUS_CODES.STATUS_03,
    JOB_STATUS_CODES.STATUS_04,
  ]).isRequired,
  handleJobStatusChange: PropTypes.func.isRequired,
  jobId: PropTypes.number.isRequired,
};

export default withStyles(styles)(JobStatus);
